import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AuthenticatedUser } from "../../types/user.types";
import { safeLogger } from "../../utils/logger";

type AuthStateType = {
  isAuthorized: boolean;
  isInitialized: boolean;
  user: AuthenticatedUser | null;
};

const initialState: AuthStateType = {
  isAuthorized: false,
  isInitialized: false,
  
  user: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<AuthenticatedUser>) => {
      safeLogger.log("User authenticated successfully");
      state.user = action.payload;
      state.isAuthorized = true;
      state.isInitialized = true;
    },
    setInitialized: (state) => {
      safeLogger.log("Auth initialized");
      state.isInitialized = true;
    },
    logout: (state) => {
      safeLogger.log("User logged out");
      state.user = null;
      state.isAuthorized = false;
      state.isInitialized = true;
    },
  },
});

export const { setAuth, setInitialized, logout } = authSlice.actions;
export default authSlice.reducer;
